export enum RouteNames {
  LOGIN = 'login',
  PROFILE = 'profile',
}
